import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import CreateListRow from '@alltrails/shared/components/CreateListRow';
import { usersContentPrivacyPolicy } from 'utils/user_helpers';
import { LISTS } from 'utils/privacy_policy_helpers';
import SaveToListModal from '@alltrails/shared/components/modals/SaveToListModal';
import { PageStrings } from '@alltrails/shared/utils/constants/pageStringHelpers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import CustomProvider from 'components/CustomProvider';

import * as styles from './styles/styles.module.scss';

const handleListCreated = list => {
  window.location.href = LanguageSupportUtil.wrapUrlSafe(`/explore/list/${list.slug}`);
};

export default function CreateListPopupButton({ context, allowEditing }) {
  const [showModal, toggleShowModal] = useState(false);

  const renderModal = () => {
    return (
      <SaveToListModal
        closeModal={() => toggleShowModal(false)}
        handleModalListCreated={handleListCreated}
        initialPrivacyPolicy={usersContentPrivacyPolicy(context, LISTS)}
        createListOnly
        page={PageStrings.LISTS_PAGE}
      />
    );
  };

  if (allowEditing) {
    return (
      <CustomProvider>
        <div className={styles.createListContainer}>
          <CreateListRow handleOnClick={() => toggleShowModal(true)} />
        </div>
        {showModal && createPortal(renderModal(), document.getElementById('modalPortal'))}
      </CustomProvider>
    );
  }
  return <></>;
}
